import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import job_opportunities_based_on_skill from '../../../assets/img/job_opportunities_based_on_skill.svg';
import {ReactComponent as DownArrowSvg} from '../../../assets/img/down-arrow.svg';
import { Modal, Spin } from "antd";
import { JobInterest } from "../../../components/JobInterest";
import JobsActions from "../jobs/jobs.actions";
import { Layout, Collapse } from "antd"
import "./styles.scss"
import CurrentJob from "./components/CurrentJob";
import Stepper from "./components/Stepper";
import { useJobModals } from '../../../hooks/job-modal.actions';
import { useJobActions } from '../../../hooks/job.actions';
import VetsmithConfirmationModal from './components/VetsmithConfirmationModal';
import { APPLICATION_STATUS, STEP_ICONS, STEPS, STEPS_DESCRIPTION, STEPS_EMPTY_TEXT, STEPS_EMPTY_TEXT_V2, STEPS_V2, STEPS_V2_DESCRIPTION } from "./constants";
import { segregateJobs } from '../../util/segregateJobs';
import removeParamFromUrl from '../../util/removeParamFromURL';
import { ToastService } from '../../../services/ToastService';
import { logJobDashboardActivity } from '../shared/JobsApplied/Jobs';

const { Panel } = Collapse;

function Jobs({
  recommendedJobs = [],
  contents = {},
  updateJobsV2,
  useApplicationTrackingUI
}) {
  const {
    recommended_jobs_empty_text = "Jobs based on your skills will be shown here. Check back regularly and keep your skills up to date."
  } = contents || {};
  if(!recommendedJobs.length) {
    return (
      <div className="no-jobs-message">
        <div className="content">
          <img src={job_opportunities_based_on_skill}/>
          <p>{recommended_jobs_empty_text}</p>
        </div>
      </div>
    )
  }

  const [currentStep, setCurrentStep] = useState(['recommended']);
  const [jobs, setJobs] = useState({
    active: [],
    recommended: [],
    submitted: [],
    archived: [],
  });
  const [stepCount, setStepCount] = useState({
    active: 0,
    recommended: 0,
    submitted: 0,
    archived: 0,
  });
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const [isDesktop, setDesktop] = useState(false);

  const [activeKeys, setActiveKeys] = useState(['recommended', 'active', 'submitted', 'archived']);

  const handlePanelChange = (newKeys) => {
    const previousKeys = Array.isArray(activeKeys) ? activeKeys : [activeKeys];
    const currentKeys = Array.isArray(newKeys) ? newKeys : [newKeys];

    const closed = previousKeys.filter((key) => !currentKeys.includes(key));
    const opened = currentKeys.filter((key) => !previousKeys.includes(key));

    if (opened.length > 0) {
      logJobDashboardActivity(
        'JOB_APPLICATIONS',
        'EXPANDED_JOB_DASHBOARD_SECTION_PANEL',
        {
          panel_name: opened[0],
          isDesktop: isDesktop,
          isMobile: !isDesktop,
        }
      )

    } else if (closed.length > 0) {
      logJobDashboardActivity(
        'JOB_APPLICATIONS',
        'COLLAPSED_JOB_DASHBOARD_SECTION_PANEL',
        {
          panel_name: closed[0],
          isDesktop: isDesktop,
          isMobile: !isDesktop,
        }
      )
    }
    setActiveKeys(newKeys);
  };

  useEffect(() => {
    const segregatedJobs = segregateJobs(recommendedJobs, useApplicationTrackingUI);
    setJobs(segregatedJobs)
    setStepCount({
      active: segregatedJobs.active.length,
      recommended: segregatedJobs.recommended.length,
      submitted: segregatedJobs.submitted.length,
      archived: segregatedJobs.archived.length,
    });

    if (useApplicationTrackingUI) {
      // open sections by default if they have entries
      const currentSteps = Object.entries(segregatedJobs)
        .filter(([_, values]) => values.length > 0)
        .map(([key]) => key);
      if (segregatedJobs.active.length > 0) {
        setCurrentStep(["active"]);
      } else {
        setCurrentStep(currentSteps);
      }
    } else {
      setCurrentStep([segregatedJobs.active && segregatedJobs.active.length ? 'active' : 'recommended']);
    }
  }, [recommendedJobs])

  useEffect(() => {
    window.addEventListener("resize", () => {
      setWindowSize(window.innerWidth);
    });
    return () => {
      window.removeEventListener("resize", () => {
        setWindowSize(window.innerWidth);
      });
    };
  }, []);

  useEffect(() => {
    setDesktop(windowSize >= 1280);
  }, [windowSize]);

  const {
    modalStates,
    modalActions
  } = useJobModals();

  const {
      loading,
      handleJobApplication,
  } = useJobActions(null, true, { jobs: recommendedJobs, updateJobsV2 });

  const queryParams = new URLSearchParams(location.search);
  const jobCode = queryParams.get('jobCode');

  useEffect(() => {
    if (jobCode) {
      if (useApplicationTrackingUI) {
        const applicationStatus = recommendedJobs.find(
          (job) => job.jobCode === jobCode
        )?.applicationStatus;
        if (
          [
            APPLICATION_STATUS.SUBMITTED,
            APPLICATION_STATUS.IN_REVIEW,
            APPLICATION_STATUS.REVIEW_COMPLETED,
            APPLICATION_STATUS.SHORTLISTED,
            APPLICATION_STATUS.SELECTED_FOR_ANOTHER_JOB,
            APPLICATION_STATUS.SELECTED,
            APPLICATION_STATUS.ARCHIVED,
          ].includes(applicationStatus)
        ) {
          ToastService.info(
            `You have already applied for this job. You can check your application status in the jobs list.`
          );
          removeParamFromUrl("jobCode");
          return;
        }
      }

      handleJobApplication({
        onShowJobRequestModal: (idHash, jobId, blockReason) => {
          modalActions.setSelectedJobIdHash(idHash);
          modalActions.setSelectedJobId(jobId);
          modalActions.setBlockSubmissionReason(blockReason);
          modalActions.showJobRequestModal();
        },
        onOpenVetsmithModal: (job) => {
          modalActions.setIcfJob(job);
          modalActions.openVetsmithConfirmationModal();
        }
      }, jobCode);
      removeParamFromUrl('jobCode');
    }
  }, [jobCode]);

  const renderJobs = (key) => {
    const sectionJobs = jobs[key];
    if (!sectionJobs || !sectionJobs.length) {
      if (!useApplicationTrackingUI) {
        return (
          <div className="content">
            <p>{STEPS_EMPTY_TEXT[key]}</p>
          </div>
        );
      }
      return (
        <div className="gray-content">
          <p>{STEPS_EMPTY_TEXT_V2[key]}</p>
        </div>
      );
    }    
    return <div className="jobs-container">
      {sectionJobs.map((job) => (
        <CurrentJob
          key={job.id}
          job={job}
          contents={contents}
          useApplicationTrackingUI={useApplicationTrackingUI}
          panelKey={key}
        />
      ))}
    </div>
  }

  const onCurrentStepChanged = (step) => {
    setCurrentStep(step);
    setActiveKeys(step);
  };

  
  const renderPanels = () => {
    const renderPanel = (key) => {
      if(!isDesktop && !currentStep.includes(key)) return null;
      
      const panelHeader = () => (
        <div>
          <h3 className="panel-title">{STEPS[key]}</h3>
          <p className="panel-info">{STEPS_DESCRIPTION[key]}</p>
        </div>
      )
  
      return <Panel
        header={panelHeader()}
        key={key}
        showArrow={isDesktop}
      >
        {renderJobs(key)}
      </Panel>
    }
    return (
      <>
        {renderPanel('active')}
        {renderPanel('recommended')}
        {renderPanel('submitted')}
      </>
    )
  }

  const renderPanelsV2 = () => {
    const renderPanel = (key) => {
      if(!isDesktop && !currentStep.includes(key)) return null;
      const Icon = STEP_ICONS[key];
      const panelHeader = () => (
        <div>
          <h3 className="panel-title">
            <Icon />
            {STEPS_V2[key]}
          </h3>
        </div>
      );
      
      return <Panel
        header={panelHeader()}
        key={key}
        showArrow={isDesktop}
        >
        <p className="panel-info">{STEPS_V2_DESCRIPTION[key]}</p>
        {renderJobs(key)}
      </Panel>
    }
    return (
      <>
        {renderPanel('recommended')}
        {renderPanel('active')}
        {renderPanel('submitted')}
        {renderPanel('archived')}
      </>
    )
  }
  
  const renderPanelExtraText = (isActive, panelKey) => {
    if (useApplicationTrackingUI) {
      return (
        <div className="panel-extra-count">
          <span className="extra-text">{stepCount[panelKey]}</span>
        </div>
      )
    }
    return (
      <span className="extra-text">{isActive ? 'Collapse' : 'Expand'}</span>
    )
  }
  return (
    <div className="turing-job-new-ui-ux">
      <div className="turing-job-new-ui-ux--main-section">
        <Stepper
          steps={STEPS}
          stepCount={stepCount}
          currentStep={currentStep}
          setCurrentStep={onCurrentStepChanged}
          isDesktop={isDesktop}
          useApplicationTrackingUI={useApplicationTrackingUI}
        >
          <Layout style={{ minWidth: '100%' }}>
            {loading && <Spin />}
            <Collapse bordered={false} activeKey={activeKeys}

                      onChange={val => {
                        logJobDashboardActivity(
                          'JOB_APPLICATIONS',
                          'CLICKED_ON_JOB_DASHBOARD_SECTION_PANEL',
                          {
                            active_sections: val,
                            isDesktop: isDesktop,
                            isMobile: !isDesktop,
                          }
                        )
                        if (isDesktop) {
                          setCurrentStep(val);
                        }
                        handlePanelChange(val);
                      }}
                      expandIconPosition="right"
                      expandIcon={({ isActive, panelKey }) => {
                        return (
                          <div className="custom-expand-icon">
                            {renderPanelExtraText(isActive, panelKey)}
                            <span className={`arrow ${isActive ? "open" : ""}`}><DownArrowSvg fill="#0F0F0F"/></span>
                          </div>
                        )
                      }}
                      className="custom-collapse">
              {useApplicationTrackingUI ? renderPanelsV2() : renderPanels()}
            </Collapse>
          </Layout>
          {modalStates.selectedJobIdHash && <Modal
            key='job-description'
            title={modalStates.previewJrf ? 'SUBMITTED APPLICATION' : 'APPLY FOR THIS JOB OPPORTUNITY'}
            visible={modalStates.isJobRequestModalVisible}
            onCancel={modalActions.hideJobRequestModal}
            footer={null}
            className="full-width-modal"
          >
            <JobInterest jobId={modalStates.selectedJobId} hash={modalStates.selectedJobIdHash} blockSubmissionReason={modalStates.blockSubmissionReason}
                         preview={modalStates.previewJrf}/>
          </Modal>}
          {modalStates.vetsmithConfirmationModal && <VetsmithConfirmationModal 
            job={modalStates.icfJob}
            setVetsmithConfirmationModal={modalActions.closeVetsmithConfirmationModal}
          />}
        </Stepper>
      </div>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  const recommendedJobs = state.jobs.jobsV2;
  return {
    recommendedJobs,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateJobsV2: () => dispatch(JobsActions.UPDATE_JOBS_V2)
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Jobs));